import config from '@/config.js'

const UnleashFlagTurnOnTimeMapProd = {
  'audience-poll-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-scale-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-wordcloud-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-reaction-emqx': new Date(Date.UTC(2025, 0, 9, 0, 0, 0)), // 16h00 UTC+7 9/1/2025
  'kv-sync-emqx-for-live-stats': new Date(Date.UTC(2025, 0, 16, 0, 0, 0)), // 7h UTC+7 16/1/2025
  'remove-leaderboard-slides': new Date(Date.UTC(2025, 1, 20, 0, 0, 0)), // 7h UTC+7 20/2/2025
}

const UnleashFlagTurnOnTimeMapDev = {
  'audience-poll-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-scale-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-wordcloud-emqx': new Date(Date.UTC(2024, 11, 10, 7, 0, 0)), // 14h UTC+7 10/12/2024
  'audience-reaction-emqx': new Date(Date.UTC(2024, 10, 12, 9, 0, 0)), // 16h00 UTC+7 12/11/2024
  'kv-sync-emqx-for-live-stats': new Date(Date.UTC(2025, 0, 16, 0, 0, 0)), // 18h00 UTC+7 25/12/2024
  'remove-leaderboard-slides': new Date(Date.UTC(2025, 2, 4, 0, 0, 0)), // 7h UTC+7 4/3/2025
}

const UnleashFlagTurnOnTime = config.env === 'production' ? UnleashFlagTurnOnTimeMapProd : UnleashFlagTurnOnTimeMapDev

export default UnleashFlagTurnOnTime
